import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { PaginationHelpers as Page } from '../../../../../helpers';
import { Pagination, Loader } from '../../../../common/elements';
import { ThreadList } from './elements/ThreadList';
import { Link } from 'react-router';
import { getThreads } from '../../../../../actions/forums/forums';
import ThemePageBanner from '../../../../dashboardNew/components/ThemePageBanner';
import BackButton from '../../../../dashboardNew/components/tools/BackButton'

class Threads extends Component {

	state = {
		bannerObj: ''
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		const {
			params,
			location,
			getThreads } = this.props,
			page = location.query.page;
		getThreads(page ? page : 1, params.categoryId);
		const locationUrl = window.location.pathname.split('/')[2];
		let bannerObj
		switch (locationUrl) {
			case '1':
				bannerObj = { title: 'General Discussion', img: '/images/bg-members.jpg' }
				break;
			case '2':
				bannerObj = { title: 'Recruitment', img: '/images/bg-forum.jpg' }
				break;
			case '3':
				bannerObj = { title: 'Introductions', img: '/images/contact.jpg' }
				break;
			default:
				bannerObj = { title: 'Introductions', img: '/images/contact.jpg' }
		}

		this.setState({ bannerObj })
	};

	getNextThreads(page) {
		const { params, getThreads } = this.props;
		getThreads(page, params.categoryId);
		browserHistory.push(`/forums/${params.categoryId}/threads?page=${page}#topofforum`);
	};

	render() {
		const {
			threads,
			params,
			paging,
			location } = this.props;

		if (!threads) return <Loader />;
		const totalPages = paging.total_pages,
			pageLocation = location.query.page,
			currentPage = Page.setCurrentPage(pageLocation, totalPages),
			pagination_details = Page.getCurrentPage(currentPage, totalPages),
			pageNumbers = Page.getPageNumbers(pagination_details);

		return (
			<section className="forum-body" id="topofforum">
				<ThemePageBanner heading={this.state.bannerObj.title} image={this.state.bannerObj.img} />
				<div className="container padding-top">
					<div className="row">
						<div className="col-xs-12">
							<div className="col-12 forum-buttons">
								<BackButton
									title="Go to Forum"
									path="/forums"
								/>

								<Link to={`/forums/${params.categoryId}/create-thread`} className="theme-button">
									<span className="new-thread-button">Create New Thread</span>
								</Link>
							</div>
							<br />
						</div>
						<div className="col-xs-12">
							<ThreadList threads={threads} category={params.categoryId} />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-12">
							{
								totalPages > 1 ?
									(
										<Pagination
											currentPage={currentPage}
											pagination={pagination_details}
											pageNumbers={pageNumbers}
											totalPages={totalPages}
											onPaginationClick={(currentPage) => this.getNextThreads(currentPage)}
										/>
									) : ''
							}
						</div>
					</div>
				</div>
			</section>
		);
	};
}

Threads.propTypes = {
	threads: PropTypes.array,
	paging: PropTypes.object,
	getThreads: PropTypes.func,
}

const mapStateToProps = (state) => {
	return {
		threads: state.forums.threads,
		paging: state.forums.pagination,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getThreads: (page, categoryId) => dispatch(getThreads(page, categoryId))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Threads);



// WEBPACK FOOTER //
// src/client/components/site/features/forums/pages/Threads.js